import { SpecsListingTypeFields, SpecsPropertyTypeFields } from '../../types/config/specs/specs';
import { Config } from '../../types/config/config';
import { Listing } from '../../types/listing/listing';
import { getMatchedConditions } from './fields-by-condition';

export const findSpecificationFieldsByConditions = (config:Config, listing: Listing ):SpecsListingTypeFields | undefined => {
    const matchedConditions = getMatchedConditions(config.featureFlags.specificationsRules || [], listing);
    if(!matchedConditions || !matchedConditions.target || !matchedConditions.target.fields) {
        return;
    }
    const allFields = config.specifications.fields;
    const fieldsToConsider:SpecsListingTypeFields = matchedConditions.target.fields;
    const fieldsSetup:SpecsListingTypeFields = Object.entries(fieldsToConsider).reduce((acc, [key, value]) => {
        const baseField = allFields[key];
        if(!baseField) {
            return acc;
        }
        acc[key] = {
            ...baseField,
            required: value.required || baseField.required || false,
            show: true,
            properties: value.properties ? {...baseField.properties, ...value.properties} : baseField.properties,
            grid: value.grid ? {...baseField.grid, ...value.grid} : baseField.grid,
        };
        return acc;
    }, {});
    return fieldsSetup;
}

export const findSpecificationFields = (config:Config, listing: Listing):SpecsListingTypeFields | undefined => {

    const { propertyType, listingType} = listing

    if(!config || !propertyType || propertyType.length === 0 || !listingType || propertyType.length === 0){
        return;
    }

    if(config.featureFlags && config.featureFlags.specificationsRules && config.specifications.fields) {
        return findSpecificationFieldsByConditions(config, listing);
    }

    let fieldSetups:SpecsListingTypeFields | undefined;

    // find the correct field configuration
    if(config && config.specifications){
        // find the correct place where we will pull the fields from using the property type

        Object.keys(config.specifications).forEach(key => {

            if(config.specifications[key]){

                const propertyTypeCandidate:SpecsPropertyTypeFields = config.specifications[key];

                if(propertyTypeCandidate.values && propertyTypeCandidate.values.indexOf(propertyType) > -1){
                    // we know we have the right propertyType bucket, now find the listing type bucket
                    if(propertyTypeCandidate[listingType]){
                        fieldSetups = propertyTypeCandidate[listingType];
                    }
                }
            }
        });
    }

    return fieldSetups;
}